import { getI18n } from 'react-i18next';

import { ColumnConfiguration } from 'src/common/components/ConfigurableTable/models/configurableTable';

const i18n = getI18n();

export const PRODUCT_ESIM_TABLE_CONFIGURATION: ColumnConfiguration[] = [
  {
    field: 'eid',
    headerName: i18n.t('common.eid'),
    resizable: false,
    sortable: true,
    pinnable: false,
    minWidth: 280,
  },
];
